import React, { useEffect, useRef } from 'react';
import {
    enable as enableDarkMode,
    disable as disableDarkMode,
} from 'darkreader';
import { MindMapContext } from '../../Context/contex';
import DarkModeToggle, { useDarkMode } from '../DarkModeToggle';

function Modes() {
    const { dark } = useDarkMode();
    const { setDarkMode_ } = MindMapContext();
    const applied = useRef(null);

    useEffect(() => {
        if (applied.current === dark) return;
        applied.current = dark;

        if (dark) {
            enableDarkMode({ brightness: 100, contrast: 90, sepia: 10 });
        } else {
            disableDarkMode();
        }

        setDarkMode_(dark);
    }, [dark, setDarkMode_]);

    return <DarkModeToggle />;
}

export default Modes;
